import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template139: Día 5 - Hongdae
const Template139 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const heroTitle = page?.texts?.[2]?.content;
	const mainStreetTitle = page?.texts?.[3]?.content;
	const mainStreetDesc = page?.texts?.[4]?.content;
	const sabiasQueHongik = page?.texts?.[5]?.content;
	const sabiasQueBts = page?.texts?.[6]?.content;
	const freeMarketTitle = page?.texts?.[7]?.content;
	const freeMarketDesc = page?.texts?.[8]?.content;
	const sabiasQueMercado = page?.texts?.[9]?.content;
	const ambienteTitle = page?.texts?.[10]?.content;
	const ambienteDesc = page?.texts?.[11]?.content;
	const comoLlegarTitle = page?.texts?.[12]?.content;
	const comoLlegarText = page?.texts?.[13]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const calleImage = getImageSrc("calle");
	const cafeteriaImage = getImageSrc("cafeteria");
	const hongdaeSticker = getCanvasImageUrl("hongdae-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{(portadaImage || heroTitle || hongdaeSticker) && (
				<Box sx={{ position: "relative" }}>
					{portadaImage && (
						<img
							src={portadaImage}
							alt=""
							style={{ width: "100%", height: 200, objectFit: "cover" }}
						/>
					)}
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: "32px",
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
					{hongdaeSticker && (
						<img
							src={hongdaeSticker}
							alt=""
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: isSmallScreen ? 50 : 60,
								left: 15,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px 0px" }}>
					<Box
						component="p"
						sx={{
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
						}}
					>
						{introText}
					</Box>
				</Box>
			)}

			<Box sx={{ padding: "0 12px 12px" }}>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "12px",
						marginTop: "10px",
					}}
				>
					{(mainStreetTitle || mainStreetDesc || calleImage) && (
						<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{calleImage && (
								<img
									src={calleImage}
									alt=""
									style={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: 12,
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{mainStreetTitle && (
									<Box component="h3" sx={estiloH3}>
										{mainStreetTitle}
									</Box>
								)}
								{mainStreetDesc && (
									<Box component="p" sx={estiloP}>
										{mainStreetDesc}
									</Box>
								)}
							</Box>
							{sabiasQueHongik && (
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue icono="🎸" texto={sabiasQueHongik} />
								</Box>
							)}
							{sabiasQueBts && (
								<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
									<SabiasQue icono="🎤" texto={sabiasQueBts} />
								</Box>
							)}
						</Box>
					)}

					{(freeMarketTitle || freeMarketDesc) && (
						<Box
							data-block-id="text-3"
							sx={{
								backgroundColor: "#caeae6",
								padding: "12px",
								borderRadius: "12px",
								display: "flex",
								gap: "16px",
								alignItems: "center",
								position: "relative",
							}}
						>
							<Box sx={{ width: "100%" }}>
								{freeMarketTitle && (
									<Box component="h3" sx={estiloH3}>
										{freeMarketTitle}
									</Box>
								)}
								{freeMarketDesc && (
									<Box component="p" sx={estiloP}>
										{freeMarketDesc}
									</Box>
								)}
							</Box>
							{sabiasQueMercado && (
								<Box
									sx={{
										position: "absolute",
										top: isSmallScreen ? -32 : -22,
										right: isSmallScreen ? "60%" : "50%",
									}}
								>
									<SabiasQue icono="🎨" texto={sabiasQueMercado} />
								</Box>
							)}
						</Box>
					)}

					{(ambienteTitle || ambienteDesc || cafeteriaImage) && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: "16px", position: "relative" }}>
							{cafeteriaImage && (
								<img
									src={cafeteriaImage}
									alt=""
									style={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: 12,
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{ambienteTitle && (
									<Box component="h3" sx={estiloH3}>
										{ambienteTitle}
									</Box>
								)}
								{ambienteDesc && (
									<Box component="p" sx={estiloP}>
										{ambienteDesc}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{(comoLlegarTitle || comoLlegarText) && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#caeae6",
								border: "3px solid #2e8b80",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 12,
								fontFamily: "'Poppins', sans-serif",
								color: "#333",
								width: "100%",
							}}
						>
							{comoLlegarTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: 13,
										fontWeight: 700,
										display: "flex",
										alignItems: "center",
										gap: 6,
										color: "#2e8b80",
										textTransform: "uppercase",
									}}
								>
									{comoLlegarTitle}
								</Box>
							)}
							{comoLlegarText && (
								<Box
									component="p"
									sx={{ margin: 0 }}
									dangerouslySetInnerHTML={{ __html: comoLlegarText }}
								/>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template139.thumbnail = "/images/template-1.png";

export default Template139;
